import { useIsMounted } from 'hooks/useIsMounted';
import { useAccount } from 'wagmi';

export function useAddress(): string | undefined {
  const isMounted = useIsMounted();
  const { address } = useAccount();

  return isMounted ? address : undefined;
}
